import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const DepartmentProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (token && role === "Department") {
    return children ? children : <Outlet />;
  } else {
    return <Navigate to="/department" replace />;
  }
};

export default DepartmentProtectedRoute;
